import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-2xl font-bold transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Global Career
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('free-service')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              무료 서비스
            </button>
            <button
              onClick={() => scrollToSection('insights')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Insights
            </button>
            <button
              onClick={() => scrollToSection('library')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Library
            </button>
            <button
              onClick={() => scrollToSection('consulting')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Consulting
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
